import { JsonObject, JsonProperty } from 'json2typescript';
import { BaseObject } from './base-object-model';

@JsonObject('Season')
export class Season extends BaseObject {
  @JsonProperty('id', Number, false) id: number = undefined;
  @JsonProperty('period', String, false) period: string = undefined;
}
